// Focus.jsx
import React from 'react';
import { useParams } from 'react-router-dom'; // Import useParams
import { FocusClip } from '../../components/FocusClip/FocusClip';
import { MiniClip } from '../../components/MiniClip/MiniClip';
import { CommentsSection } from '../../components/CommentsSection/CommentsSection';
import { useAudio } from '../../contexts/AudioContext';
import './Focus.css'; // Ensure the path is correct
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { pixelsToVh } from '../../helpers/PixelsToViewport';
import { getClip, getScreenshotSignedUrl, getSimilarClips } from '../../services/HalogenService';
import { FocusHeader } from './FocusHeader';
import { PLAYBACK_BAR_HEIGHT, HEADER_HEIGHT, MOBILE_HEADER_HEIGHT, MOBILE_PLAYBACK_BAR_HEIGHT } from '../../constants';
import { Helmet } from 'react-helmet';

const Focus = () => {
    const [focusClip, setFocusClip] = useState(null);
    const [relatedClips, setRelatedClips] = useState([]);
    const navigate = useNavigate();
    const paramsInfo = useParams();
    const clipId = paramsInfo.clipId;
    const maxRelatedClips = 10;
    const windowHeight = window.innerHeight;
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const { currentlyPlayingClip, addToAutoqueueAtIndex } = useAudio();

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const fetchClip = async (clipId) => {
            try {
                const clipResponse = await getClip(clipId);
                setFocusClip(clipResponse[0]);
                if (!currentlyPlayingClip) {
                    addToAutoqueueAtIndex(clipResponse[0], 0);
                }
                const similarClipsResponse = await getSimilarClips(clipId, maxRelatedClips)
                setRelatedClips(similarClipsResponse);
            } catch (error) {
                console.error(error);
                navigate('/404');
            }
        }

        if (clipId) {
            fetchClip(clipId);
        }
    }, [clipId]);

    return (
        <div className="focusPageContainer">
            <Helmet>
                <title>{focusClip ? focusClip.title : 'Lavalamp'}</title>
            </Helmet>
            <FocusHeader />
            <div className="focusContentContainer" style={{ height: `${(100 - pixelsToVh(windowWidth > 768 ? HEADER_HEIGHT + PLAYBACK_BAR_HEIGHT : MOBILE_HEADER_HEIGHT + MOBILE_PLAYBACK_BAR_HEIGHT, windowHeight))}dvh` }}>
                <div className="focusClipContainer">
                    {focusClip && <FocusClip clip={focusClip} />}
                    {focusClip && clipId &&
                        <div className='commentsSection'>
                            <CommentsSection clipId={clipId} />
                        </div>}
                </div>
                <div className='relatedClipsAndTitleContainer'>
                    <p className="moreLikeThis">More Like This</p>
                    <div className="relatedClipsContainer">
                        {relatedClips?.map(clip => (
                            <MiniClip key={clip.id} clip={clip} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Focus;
